import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import AuthCallback from "@/components/AuthCallback";
import ProtectedRoute from "@/components/ProtectedRoute";
import DashboardShell from "@/components/DashboardShell";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Overview from "@/pages/dashboard/Overview";
import Workspace from "@/pages/dashboard/Workspace";
import AppBuilder from "@/pages/dashboard/AppBuilder";
import Agents from "@/pages/dashboard/Agents";
import MediaStudio from "@/pages/dashboard/MediaStudio";
import TaxOS from "@/pages/dashboard/TaxOS";
import Accounting from "@/pages/dashboard/Accounting";
import GstOS from "@/pages/dashboard/GstOS";
import ApiKeys from "@/pages/dashboard/ApiKeys";

function AppRouter() {
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/login" element={<Login />} />
      <Route
        path="/dashboard"
        element={
          <ProtectedRoute>
            <DashboardShell />
          </ProtectedRoute>
        }
      >
        <Route index element={<Overview />} />
        <Route path="workspace" element={<Workspace />} />
        <Route path="builder" element={<AppBuilder />} />
        <Route path="agents" element={<Agents />} />
        <Route path="media" element={<MediaStudio />} />
        <Route path="taxos" element={<TaxOS />} />
        <Route path="accounting" element={<Accounting />} />
        <Route path="gstos" element={<GstOS />} />
        <Route path="api" element={<ApiKeys />} />
      </Route>
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <AppRouter />
          <Toaster position="top-right" richColors />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
